// extracted by mini-css-extract-plugin
export var defaultWrapper = "_fy-3";
export var downloadButton = "_fy-4";
export var fileContainer = "_fy-9 _fy-7";
export var fileContainerBase = "_fy-7";
export var fileContainerBaseSm = "_fy-a _fy-7";
export var fileContainerFixedHeight = "_fy-8 _fy-7";
export var fileContainerFixedHeightSm = "_fy-c _fy-a _fy-7";
export var fileContainerSm = "_fy-b _fy-a _fy-7";
export var fileInfo = "_fy-5";
export var fileInfoWidthRestricted = "_fy-6";
export var fileType = "_fy-1";
export var fileTypeName = "_fy-2";
export var fileTypeSm = "_fy-d _fy-1";
export var image = "_fy-0";
export var link = "_fy-f";
export var overflowEllipsis = "_fy-e";